import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

export default function CustomSelect({ categories, value, setValue, searchValue, clearSearchField }) {
	const [isOpen, setIsOpen] = useState(false);

	// Event listener to close the select when clicking outside
	useEffect(() => {
		const handleClickOutside = (e) => {
			!e.target.closest(`.feature__controls--select`) && setIsOpen(false);
		};

		window.addEventListener('click', handleClickOutside);

		// Cleanup function to remove the event listener
		return () => {
			window.removeEventListener('click', handleClickOutside);
		};
	}, []);

	const handleOptionClick = (slug) => {
		if (searchValue !== '') {
			clearSearchField();
		}

		setValue(slug);
		setIsOpen(false);
	};

	const handleClearClick = (e) => {
		e.stopPropagation();
		handleOptionClick('all');
	};

	const getFeatureCount = (value) => {
		const allCount = categories.all.count;

		if (value === 'all') {
			return <span className="feature__controls--select-count">({allCount})</span>;
		} else {
			return (
				<span className="feature__controls--select-count">
					({categories[value].count} / {allCount})
				</span>
			);
		}
	};

	return (
		<div className="feature__controls--select">
			<div className={`feature__controls--select-trigger ${isOpen ? 'open' : 'closed'}`} onClick={() => setIsOpen(!isOpen)}>
				<div className="feature__controls--select-trigger-wrapper" style={{ '--color': categories[value].color }}>
					{categories[value].illustration ? <span dangerouslySetInnerHTML={{ __html: categories[value].illustration }} /> : null}
					<span className="feature__controls--select-trigger-headline">{categories[value].title}</span> {getFeatureCount(value)}
				</div>

				<div className="feature__controls--select__controls">
					{value !== 'all' && <div className="feature__controls--select__controls-clear" onClick={handleClearClick}></div>}
					<div className="feature__controls--select__controls-arrow"></div>
				</div>
			</div>

			{isOpen && (
				<ul className="feature__controls--select-options">
					{Object.values(categories).map((category) => {
						return (
							<li
								key={category.slug}
								className="feature__controls--select-option"
								onClick={() => handleOptionClick(category.slug)}
								style={{ '--color': category.color }}
							>
								{category.illustration ? <span dangerouslySetInnerHTML={{ __html: category.illustration }} /> : null}
								<span className="feature__controls--select-option-headline">
									{category.title} {getFeatureCount(category.slug)}
								</span>
							</li>
						);
					})}
				</ul>
			)}
		</div>
	);
}

CustomSelect.propTypes = {
	categories: PropTypes.object.isRequired,
	value: PropTypes.string.isRequired,
	setValue: PropTypes.func.isRequired,
	searchValue: PropTypes.string.isRequired,
	clearSearchField: PropTypes.func.isRequired,
};
